const log = require('../shared_utils/log.js')
const glitchApplication = require('./glitch-application.js')

module.exports = function store (state, emitter) {
  emitter.on('toggle-glitch', glitchId => {
    if (state.selectedGlitchId === glitchId) {
      emitter.emit('deselect-glitch')
    } else {
      emitter.emit('select-glitch', glitchId)
    }
  })

  emitter.on('deselect-glitch', () => {
    state.selectedGlitchId = null
//    state.settingSpriteVariable = false
    emitter.emit('render')
  })

  emitter.on('select-glitch', glitchId => {
    log('select-glitch', glitchId)
    if (glitchId != state.selectedGlitchId) {
      const glitch = state.availableGlitches.find(g => g.id === glitchId)
      if (!glitch.exposedVariables) {
        glitch.exposedVariables = JSON.parse(JSON.stringify(glitch.defaultExposedVariables))
      }
    }
    state.selectedPartId = null
    state.selectedGlitchId = glitchId
    emitter.emit('deselect-target')
    emitter.emit('render')
  })

  emitter.on('toggle-part', partId => {
    log("toggle part")
    if (state.selectedPartId === partId) {
      emitter.emit('deselect-part')
    } else {
      emitter.emit('select-part', partId)
    }
  })

  emitter.on('select-part', partId => {
    log('select-part', partId)


    state.selectedGlitchId = null
    state.selectedPartId = partId
    emitter.emit('deselect-target')
    emitter.emit('render')
  })

  emitter.on('deselect-part', () => {
    state.selectedPartId = null
    emitter.emit('render')
  })

  emitter.on('remove-glitch-from-toolbar', glitchId => {
    log('remove-glitch-from-toolbar', glitchId)
    const glitch = state.availableGlitches.find(g => g.id === glitchId)
    log('found glitch:', glitch)
    glitch.exposedVariables = JSON.parse(JSON.stringify(glitch.defaultExposedVariables))
    log('reset variables:', glitch.exposedVariables)
    emitter.emit('deselect-all')
    emitter.emit('render')
  })
}
